/**
 * Shared mixin for metrics views that display class-level charts:
 * MetricsClassView and MetricsCustomReportView.
 * Provides performance trend + student trajectories state and shared handlers.
 */
export default {
  data() {
    return {
      performanceTrendData: { labels: [], datasets: [] },
      isPerformanceTrendLoading: false,
      selectedPeriod: "month",
      studentTrajectoriesData: { summary: {}, data: [] },
      isStudentTrajectoriesLoading: false,
    };
  },

  methods: {
    onSelectedPeriodChange(value) {
      this.selectedPeriod = value;
      this.fetchPerformanceTrend();
    },
  },
};
